import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';

const Plans = () => {

  return (
    <>
      <Container className="">
        <Row>
          <Col md={4}>
            <Card>
              <Card.Header className="bg-secondary text-white">MENSAL</Card.Header>
              <Card.Body>
                <Card.Text as="div">
                  <>
                    <div>
                      <h2><i className="bi bi-award"></i> R$ 190,00</h2>
                      <hr />
                      <div>Acesso às bases de dados de insumos e serviços da construção civil de forma organizada, completa, íntegra e com consistência técnica por <b>30 dias</b>.</div>
                      <hr />
                      <div>Consulta a preços e composições de custos via <b>Aplicativo Móvel</b>.</div>
                      <hr />
                      <div>Integração rápida e fácil com sistemas ERP e de Orçamento.</div>
                      <hr />
                      <div>Pagamento à vista no <b>Cartão de Crédito</b>.</div>
                    </div>
                  </>
                </Card.Text>
              </Card.Body>
              <Card.Footer>
                <Button variant="primary" href="purchase/1">Contratar</Button>
              </Card.Footer>
            </Card>
          </Col>

          <Col md={4}>
            <Card>
              <Card.Header className="bg-secondary text-white">ANUAL (Á Vista)</Card.Header>
              <Card.Body>
                <Card.Text as="div">
                  <div>
                    <h2><i className="bi bi-award-fill"></i> R$ 1.080,00</h2>
                    <hr />
                    <div>Acesso às bases de dados de insumos e serviços da construção civil de forma organizada, completa, íntegra e com consistência técnica por <b>365 dias</b>.</div>
                    <hr />
                    <div>Consulta a preços e composições de custos via <b>Aplicativo Móvel</b>.</div>
                    <hr />
                    <div>Integração rápida e fácil com sistemas ERP e de Orçamento.</div>
                    <hr />
                    <div>Pagamento à vista no <b>Cartão de Crédito</b>.</div>
                  </div>
                </Card.Text>
              </Card.Body>
              <Card.Footer>
                <Button variant="primary" href="purchase/2">Contratar</Button>
              </Card.Footer>
              <div className='d-flex p-2'><Badge bg="secondary" className="p-2 flex-fill">RECOMENDADO!</Badge></div>
            </Card>
          </Col>

          <Col md={4}>
            <Card>
              <Card.Header className="bg-secondary text-white">ANUAL (Parcelado)</Card.Header>
              <Card.Body>
                <Card.Text as="div">
                  <div>
                    <h2><i className="bi bi-trophy-fill"></i> 4 x R$ 310,00</h2>
                    <hr />
                    <div>Acesso às bases de dados de insumos e serviços da construção civil de forma organizada, completa, íntegra e com consistência técnica por <b>365 dias</b>.</div>
                    <hr />
                    <div>Consulta a preços e composições de custos via <b>Aplicativo Móvel</b>.</div>
                    <hr />
                    <div>Integração rápida e fácil com sistemas ERP e de Orçamento.</div>
                    <hr />
                    <div>Pagamento à vista no <b>Cartão de Crédito</b>.</div>
                  </div>
                </Card.Text>
              </Card.Body>
              <Card.Footer>
                <Button variant="primary" href="purchase/3">Contratar</Button>
              </Card.Footer>
            </Card>
          </Col>

        </Row>
      </Container>
    </>
  );
};

export default Plans;